import styled from "styled-components";

export const JackpotBetPrizeAmountContainerDefaultBox = styled.div`
  background: linear-gradient(180deg, #FFE600 17.85%, #FCD303 87.26%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 19.2px;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  transition: opacity 0.25s ease-in, transform 0.25s ease-in;
  display: inline-block;
`;
